import React from 'react';
import {
  Typography,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { products } from '../../data/products';
import PageLayout from '../../components/PageLayout';
import ProductCard from '../../components/ProductCard';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#1a1a1a',
  marginBottom: '1rem',
  textAlign: 'center',
});

const HighJewelryPage = () => {
  const highJewelryProducts = products.filter(product => product.category === 'high-jewelry');

  return (
    <PageLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <PageTitle>High Jewelry</PageTitle>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          align="center"
          sx={{ mb: 6 }}
        >
          Experience the pinnacle of luxury with our exclusive high jewelry collection, featuring exceptional pieces crafted with the finest materials and exquisite craftsmanship
        </Typography>

        <Grid container spacing={4}>
          {highJewelryProducts.map((product) => (
            <Grid item key={product.id} xs={12} sm={6} md={4}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </PageLayout>
  );
};

export default HighJewelryPage;
